<template>
  <component
    :is="componentTag"
    :href="componentHref"
    :class="componentClass"
    class="help-center-category-item__component"
    @click="onClick"
  >
    <i
      v-if="isPrimary"
      class="help-center-category-item__icon"
      :class="category.icon"
    />
    <span class="help-center-category-item__title">
      {{ category.title }}
    </span>
    <template v-if="withChevrons">
       <HelpCenterIcon
        :class="chevronUpClass"
        class="help-center-category-item__chevron"
        name="chevronUp"
        size-units="5"
      />
      <HelpCenterIcon
        :class="chevronDownClass"
        class="help-center-category-item__chevron"
        name="chevronDown"
        size-units="5"
      />
    </template>
  </component>
</template>

<script setup>
import { computed } from 'vue'
import isLeftClick from 'gleam-shared/browser/isLeftClick'
import HelpCenterIcon from 'help-center/components/HelpCenterIcon'

const emit = defineEmits(['navigate'])
const props = defineProps({
  category: {
    type: Object,
    required: true
  },
  isItem: {
    type: Boolean,
    required: true
  },
  isPrimary: {
    type: Boolean,
    required: true
  },
  selectedCategory: Object,
  withChevrons: Boolean,
  chevronUpClass: String,
  chevronDownClass: String
})

const isSelected = computed(() => {
  return props.category === props.selectedCategory
})

const componentTag = computed(() => {
  if (props.isItem) {
    return 'a'
  } else {
    return 'summary'
  }
})

const componentHref = computed(() => {
  if (props.isItem) {
    return props.category.url
  } else {
    return null
  }
})

const componentClass = computed(() => {
  return {
    'help-center-category-item__component--primary': props.isPrimary,
    'help-center-category-item__component--selected': isSelected.value
  }
})

function onClick(event) {
  if (props.isItem && isLeftClick(event)) {
    emit('navigate')
  }
}
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-category-item {
  &__component {
    @include reset-summary;
    @include help-center-accent-link($offset: 2px, $selector: '.help-center-category-item__title');
    @include help-center-font(14);

    gap: 8px;
    display: flex;
    align-items: center;

    &--primary {
      @include help-center-font(16);
    }

    &--selected {
      font-weight: var(--help-center-bold);
    }
  }

  &__icon {
    @include help-center-icon(16);
    color: var(--help-center-muted);
    flex: none;
  }

  &__title {
    flex: auto;
  }

  &__chevron {
    color: var(--help-center-muted);
    flex: none;
  }
}
</style>
